import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql, compose } from 'react-apollo';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import CreateListingModal from '../CreateListingModal';

import { removeListing } from '../../../actions/siteadmin/ListingManagement/removeListing';
import { addListToRecommended, removeListFromRecommended } from '../../../actions/siteadmin/ListingManagement/manageRecommend';
import listingsQuery from './listingsQuery.graphql';
import messages from '../../../locale/messages';

import s from './ListingManagement.css';
import cs from '../../../components/commonStyle.css';

class ListingManagement extends React.Component {

  static propTypes = {
    getAllListings: PropTypes.array,
    title: PropTypes.string.isRequired,
    addListToRecommended: PropTypes.func.isRequired,
    removeListFromRecommended: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      showCreateModal: false,
    }
    this.openCreateModal = this.openCreateModal.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this);
  }

  openCreateModal() {
    this.setState({ showCreateModal: true });
  }

  closeCreateModal() {
    this.setState({ showCreateModal: false });
  }
  paginationData = (currentPage) => {
    const { getAllListings: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }
  handleClick = (searchList) => {
    const { getAllListings: { refetch }, setStateVariable } = this.props;
    const { currentPage } = this.state;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    setStateVariable(variables);
    refetch(variables);
  }
  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  deleteListing = async (id, type) => {
    const { removeListing, currentPage } = this.props;
    const { getAllListings: { refetch, getAllListings }, setStateVariable } = this.props;
    let variables = { currentPage: currentPage > 1 && getAllListings?.usersData?.length == 1 ? currentPage - 1 : currentPage };
    const response = await removeListing(id, type);
    if (response?.status == 200) {
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.adminTitleLabel) },
      { data: formatMessage(messages.carOwnerName) },
      { data: formatMessage(messages.carOwnerEmail) },
      { data: formatMessage(messages.address) },
      { data: formatMessage(messages.city) },
      { data: formatMessage(messages.stateLabel) },
      { data: formatMessage(messages.country) },
      { data: formatMessage(messages.createdDate) },
      { data: formatMessage(messages.recommendLabel) },
      { data: formatMessage(messages.publishedLabel) },
      { data: formatMessage(messages.ready) },
    ]
  };

  tbody = () => {
    const { getAllListings: { getAllListings } } = this.props;
    const { currentPage, searchList, addListToRecommended, removeListFromRecommended } = this.props;
    const { formatMessage } = this.props.intl;

    return getAllListings?.usersData.map(value => {
      const listingTitle = value?.title
        ? value.title
        : (value.settingsData && value.settingsData[0]?.listsettings?.itemName
          ? value.settingsData[0].listsettings.itemName + ' in ' + value?.city
          : 'Listing #' + value.id);
      return {
        id: value?.id,
        data: [
          { data: value.id },
          {
            data:
              <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
                <a href={"/cars/" + value.id} target='_blank'>
                  {value?.title ? value.title : value.settingsData[0]?.listsettings?.itemName + " in " + value?.city}
                </a>

                <TableAction
                  deleteConfirmItemName={listingTitle}
                  onClickDelete={() => this.deleteListing(value.id, "admin")}
                  showDelete={true}
                  showView={true}
                  newLink={"/cars/" + value.id}
                  showEdit
                  editNewLink={'/become-a-owner/' + value.id + '/home'}
                />
              </div>
          },
          { data: value?.user?.profile?.firstName },
          { data: value?.user?.email },
          { data: value.street + ', ' + value.city + ', ' + value.state + ', ' + value.country + ', ' + value.zipcode },
          { data: value?.city },
          { data: value?.state },
          { data: value?.country },
          { data: moment(value?.createdAt).format('MM/DD/YYYY') },
          {
            data: <>
              {
                value.recommend != null &&
                <a href="javascript:void(0)" onClick={() => removeListFromRecommended(value.id, currentPage, searchList)} >
                  <FormattedMessage {...messages.remove} />
                </a>
              }
              {
                value.recommend == null &&
                <a href="javascript:void(0)" onClick={() => addListToRecommended(value.id, currentPage, searchList)} >
                  <FormattedMessage {...messages.setLabel} />
                </a>
              }
            </>
          },
          { data: value.isPublished ? formatMessage(messages.yesLabel) : formatMessage(messages.noLabel) },
          { data: value.isReady ? formatMessage(messages.yesLabel) : formatMessage(messages.noLabel) },
        ]
      }
    })
  }

  render() {
    const { getAllListings: { loading, getAllListings } } = this.props;
    const { currentPage, searchList } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.pagecontentWrapper)}>
        <CreateListingModal
          show={this.state.showCreateModal}
          onClose={this.closeCreateModal}
        />
        <CommonTable
          thead={this.thead}
          tbody={this.tbody}
          title={formatMessage(messages.listingsManagement)}
          isExport
          exportLink={`/export-admin-data?type=listings&search=${searchList}`}
          isSearch
          onSearch={this.handleSearchChange}
          isLink
          addAction={this.openCreateModal}
          redirectionLabel={formatMessage(messages.createListingForHost)}
        />
        {
          getAllListings?.usersData?.length > 0
          && <div>
            <CustomPagination
              total={getAllListings.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.listings)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({
});

const mapDispatch = {
  removeListing,
  addListToRecommended,
  removeListFromRecommended
};
export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch),
  graphql(listingsQuery, {
    name: 'getAllListings',
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: props.searchList
      },
      fetchPolicy: 'network-only',
    })
  })
)(ListingManagement);